import axios from 'axios';
import {createAction} from 'redux-actions';

export const toggleMainNav = createAction('MAIN_NAV_TOGGLE');
export const getMenus = createAction('GET_MENUS', async () => {
	const {data} = await axios(`${API}/wp-api-menus/v2/menus`);
	return Promise.all(data.map(async x => (await axios(`${API}/wp-api-menus/v2/menus/${x.ID}`)).data));
});



// WEBPACK FOOTER //
// actions/menus.js